import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

// Magnetic hover button — subtle pull toward cursor.
export const MagneticButton = ({
    to,
    href,
    children,
    testid,
    target,
    rel,
    variant = "primary",
    className = "",
}) => {
    const ref = useRef(null);
    const [pos, setPos] = useState({ x: 0, y: 0 });

    const handleMove = (e) => {
        const el = ref.current;
        if (!el) return;
        const r = el.getBoundingClientRect();
        const x = e.clientX - (r.left + r.width / 2);
        const y = e.clientY - (r.top + r.height / 2);
        setPos({ x: x * 0.18, y: y * 0.18 });
    };

    const reset = () => setPos({ x: 0, y: 0 });

    const baseCls =
        "relative inline-flex items-center gap-3 px-7 md:px-9 py-3.5 md:py-4 text-[13px] tracking-wide font-medium transition-colors duration-300 group select-none";
    const cls =
        variant === "primary"
            ? `${baseCls} bg-[#111111] text-white hover:bg-[#222222]`
            : variant === "ghost-light"
              ? `${baseCls} border border-white/40 text-white hover:bg-white hover:text-[#111111]`
              : `${baseCls} border border-[#111111] text-[#111111] hover:bg-[#111111] hover:text-white`;

    const inner = (
        <motion.span
            ref={ref}
            onMouseMove={handleMove}
            onMouseLeave={reset}
            animate={{ x: pos.x, y: pos.y }}
            transition={{ type: "spring", stiffness: 220, damping: 18, mass: 0.4 }}
            className={`${cls} ${className}`}
        >
            <span>{children}</span>
            <span
                aria-hidden
                className="inline-block transition-transform duration-500 group-hover:translate-x-1"
            >
                →
            </span>
        </motion.span>
    );

    if (to) {
        return (
            <Link to={to} data-testid={testid} className="inline-block">
                {inner}
            </Link>
        );
    }
    return (
        <a
            href={href}
            target={target}
            rel={rel}
            data-testid={testid}
            className="inline-block"
        >
            {inner}
        </a>
    );
};
